// extracted by mini-css-extract-plugin
export default {"root":"H2SAZ","iconWrapper":"odyYF","hidden":"aDdIQ"};